(function () {
  var FREE_GIFT_VARIANT_ID = '48136683192541';
  var THRESHOLD = 149900; // ₹1499 in paise
  var GIFT_PROP = '_free_gift';
  var DEBOUNCE_MS = 600; // wait for cart to settle before acting
  // Set in theme.liquid: false once a logged-in customer has placed 3+ orders.
  var ELIGIBLE = window.FREE_GIFT_ELIGIBLE !== false;

  var ensurePromise = null; // in-flight gift check, shared so callers don't stack
  var debounceTimer = null;

  function giftLine(items) {
    return items.find(function (item) {
      return (
        String(item.variant_id) === String(FREE_GIFT_VARIANT_ID) &&
        item.properties &&
        item.properties[GIFT_PROP] === 'true'
      );
    });
  }

  function subtotalWithoutGift(items) {
    return items.reduce(function (sum, item) {
      var isGift =
        String(item.variant_id) === String(FREE_GIFT_VARIANT_ID) &&
        item.properties &&
        item.properties[GIFT_PROP] === 'true';
      return isGift ? sum : sum + item.final_line_price;
    }, 0);
  }

  function addGift() {
    return fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(FREE_GIFT_VARIANT_ID), quantity: 1, properties: { [GIFT_PROP]: 'true' } }],
      }),
    }).then(function (res) { if (!res.ok) throw new Error('add failed'); });
  }

  function removeGift(key) {
    return fetch(Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(function (res) { if (!res.ok) throw new Error('remove failed'); });
  }

  function refreshUI() {
    // Re-fetch the latest cart state and dispatch cart:refresh so the drawer
    // and cart page both reflect the sipper add/remove.
    fetch(Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      })
      .catch(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      });
  }

  // Fetch fresh cart state, then add or remove the gift as needed.
  // Always reads from the server so we never act on stale event data.
  // Returns a promise that resolves once the cart is settled, so checkout
  // navigation can wait on it.
  function ensureGift() {
    if (ensurePromise) return ensurePromise;
    clearTimeout(debounceTimer);
    debounceTimer = null;

    ensurePromise = fetch(Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var subtotal = subtotalWithoutGift(items);
        var gift = giftLine(items);

        if (!ELIGIBLE) {
          // Past the 3rd order: never add, and clear any gift already in cart.
          return gift ? removeGift(gift.key).then(refreshUI) : undefined;
        }

        if (subtotal >= THRESHOLD && !gift) {
          return addGift().then(refreshUI);
        } else if (subtotal < THRESHOLD && gift) {
          return removeGift(gift.key).then(refreshUI);
        }
      })
      .catch(function (err) { console.error('[free-gift]', err); })
      .finally(function () { ensurePromise = null; });

    return ensurePromise;
  }

  // Debounce: wait DEBOUNCE_MS after the last cart event before acting.
  // This prevents race conditions when the user clicks + rapidly or when
  // multiple cart:change events fire in quick succession.
  function scheduleCheck() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      ensureGift();
    }, DEBOUNCE_MS);
  }

  document.addEventListener('cart:change', scheduleCheck);

  document.addEventListener('DOMContentLoaded', function () {
    ensureGift();
  });

  // ── Buy Now ────────────────────────────────────────────────────────────────
  // Shopify's dynamic checkout button creates a checkout that bypasses the
  // cart, so the gift can never ride along. Intercept the click before the
  // button's own handler runs (capture phase on document fires first), route
  // the item through the real cart, settle the gift, then go to checkout.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.shopify-payment-button__button') : null;
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var idEl = form.elements.namedItem('id');
    var qtyEl = form.elements.namedItem('quantity');
    var id = idEl && idEl.value;
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    if (!id) return;

    btn.setAttribute('aria-busy', 'true');

    fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }),
    })
      .then(function (res) { if (!res.ok) throw new Error('buy now add failed'); })
      .then(ensureGift)
      .then(function () { window.location.href = Shopify.routes.root + 'checkout'; })
      .catch(function (err) {
        console.error('[free-gift] buy now', err);
        btn.removeAttribute('aria-busy');
      });
  }, true);

  // ── Checkout race ──────────────────────────────────────────────────────────
  // Clicking Checkout while a debounced gift check is still pending would
  // create the checkout before the gift lands. Hold the click, settle the
  // gift, then continue.
  document.addEventListener('click', function (e) {
    if (!debounceTimer && !ensurePromise) return; // cart already settled
    var el = e.target.closest
      ? e.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]')
      : null;
    if (!el) return;

    e.preventDefault();
    e.stopPropagation();
    ensureGift().finally(function () {
      window.location.href = Shopify.routes.root + 'checkout';
    });
  }, true);

  // Shared config for other scripts that build checkouts themselves
  // (hydration calculator Buy Now).
  window.FreeGift = {
    GIFT_VARIANT_ID: FREE_GIFT_VARIANT_ID,
    THRESHOLD_PAISE: THRESHOLD,
    GIFT_PROP: GIFT_PROP,
    ELIGIBLE: ELIGIBLE,
    ensure: ensureGift,
  };
})();
